export enum NetSuiteRecordCurrency {
  Shop = "shop",
  Presentment = "presentment",
}
